const point_coords = [[58.139030992915956,52.83855650887375]]
const point_address = ['Автономная некоммерческая организация «Ресурсно-информационный центр «ДондыДор»']
const center_coords = [58.14008738488751,52.85212186657539]
const zoom_coords = 15
const icon_size = [130,130]
const icon_offset = [-75,-130]
const icon_path = 'img/point_map.svg'

jQuery(document).ready(function($){

function init() {
    const id = 'map';
    const myMap = new ymaps.Map(id, {
        center: center_coords,
        zoom: zoom_coords,
    });
    // coords: 55.6350,37.3458

    myMap.behaviors.disable('scrollZoom');
    //myMap.behaviors.disable('drag');
    myMap.controls.remove('geolocationControl');
    myMap.controls.remove('searchControl');
    myMap.controls.remove('trafficControl');
    myMap.controls.remove('typeSelector');
    myMap.controls.remove('fullscreenControl');
    myMap.controls.remove('rulerControl');

    for (let i=0; i < point_coords.length; i++) {

        const myPlacemark = new ymaps.Placemark(point_coords[i], {
            balloonContent: point_address[i]
        }, {
            // Опции.
            iconLayout: 'default#image',
            iconImageHref: icon_path,
            iconImageSize: icon_size,
            iconImageOffset: icon_offset
        });

        myMap.geoObjects.add(myPlacemark);

    }
};
if ($('#map').length > 0) ymaps.ready(init);

})